import { Auth, base, getEnv } from '@/utils';

const { GO_ENDPOINT } = getEnv();

type PutUserCardV2Props = {
  userId: string;
  setup_intent: string;
  setup_intent_client_secret: string;
  redirect_status: string;
};

export const putUserCardV2 = async ({
  userId,
  ...params
}: PutUserCardV2Props) => {
  const token = await Auth.getIdToken();
  const response = await base.put(
    `${GO_ENDPOINT}/v1/users/${userId}/cards`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
